export function isUserAgentIE() {
  return /Trident/.test(navigator.userAgent);
}
